module.exports = __webpack_public_path__ + "static/media/placeholder.7817861d.svg";